import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import api from "../lib/api";

export default function Layout() {
  useEffect(() => {
    // Count once per browser session (refresh = same session, no double count)
    if (typeof window !== "undefined" && !sessionStorage.getItem("th_tracked")) {
      sessionStorage.setItem("th_tracked", "1");
      api.post("/track").catch(() => {
        sessionStorage.removeItem("th_tracked");
      });
    }
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
